// extracted by mini-css-extract-plugin
export default {"shipping":"Ah-z","header":"Bh-z","adjustMarginAndPaddingNewDesign":"Ch-z"};